import { useAtomValue } from 'jotai';

import { aggregationsAtom } from '@core/Atoms/Search/AggregationsAtom';
import { MultiSelect } from '@plp/Components/MultiSelect/MultiSelect';
import { getOptionsWithAggs } from '@plp/Utils/Filters/GetOptionsWithAggs';
import { useMultiSelectFilters } from '@search-filters/Hooks/UseMultiSelectFilters';

import type { FilterControlBaseProps } from '../../FilterPanel.entity';
import ApplyButton from '../ApplyButton/ApplyButton';
import { GEARBOXS } from './GearboxFilter.constants';

import styles from './GearboxFilter.module.css';

type GearboxFilterProps = FilterControlBaseProps;

export const GearboxFilter = ({
  strings,
  isPlpFiltersSeoEnabled,
  tenant,
  applyButton,
}: GearboxFilterProps) => {
  const aggs = useAtomValue(aggregationsAtom);

  const { handleSelect, handleApply, listWithSelected } = useMultiSelectFilters(
    'gear-box',
    getOptionsWithAggs(GEARBOXS, aggs['gear-box']),
    strings,
    isPlpFiltersSeoEnabled,
    tenant,
    undefined,
    applyButton,
  );

  return (
    <section className={styles.gearboxFilter}>
      <MultiSelect
        groupName="gear-box"
        classes={{ label: styles.listItem }}
        items={listWithSelected}
        onSelect={(id, checked) => {
          handleSelect(id, checked);
        }}
        dataTestId="gearbox-filter-list"
        applyButton={applyButton}
      />
      {applyButton && <ApplyButton handleApply={handleApply} ctaText={strings.apply} />}
    </section>
  );
};
